<template>
  <div>
    <div style="display: flex; justify-content: space-between;">
      <h3 class="BgNeurofeedback__title">Neurofeedback</h3>
      <p
        style="cursor: pointer; font-size: 10pt; margin-bottom: 10px;"
        @click="
          $store.commit('SET_TEST_TRANSLATION', !$store.state.test.translation)
        "
      >
        <u>
          {{
            $store.state.test.translation
              ? "Original"
              : $store.state.test.translation_language
          }}</u
        >
      </p>
    </div>
    <transition-group transition-group name="list-complete" tag="div">
      <div
        class="BgNeurofeedback"
        key="skelly"
        v-if="activePoints.length === 0"
      >
        <div class="BgNeurofeedback__emotion-holder">
          <div
            :class="`BgNeurofeedback__bubble BgNeurofeedback__bubble--gray`"
          />
          <div
            class="
              BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--title
            "
          ></div>
        </div>
        <div
          :class="`BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--1`"
        />
        <div
          :class="`BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--2`"
        />
        <div
          :class="`BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--3`"
        />
        <div
          :class="`BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--4`"
        />
        <div
          :class="`BgNeurofeedback__skelly-bar BgNeurofeedback__skelly-bar--5`"
        />
      </div>
      <div
        class="BgNeurofeedback"
        :key="point.id"
        v-for="point in activePoints"
      >
        <div class="BgNeurofeedback__header">
          <div class="BgNeurofeedback__emotion-holder">
            <div
              :class="
                `BgNeurofeedback__bubble BgNeurofeedback__bubble--${point.emotion.toLowerCase()}`
              "
            />
            <div class="BgNeurofeedback__emotion">
              {{ point.emotion.toLowerCase() }}
            </div>
          </div>
          <div :class="`BgNeurofeedback__bubble__timestamp`">
            {{ timestamp(point.timestamp_top) }}
          </div>
        </div>
        <div v-if="point.tags.length > 0">
          <router-link
            v-for="tag in point.tags"
            :key="tag.id"
            :class="
              `BgNeurofeedback__element BgNeurofeedback__element--${point.emotion.toLowerCase()}`
            "
            :to="`/test/${$route.params.id}/tags?tag=${tag.id}`"
            target="_blank"
            >#{{ tag.name }}</router-link
          >
        </div>
        <div class="BgNeurofeedback__feedback">
          <span v-if="!$store.state.test.translation">
            {{
              point.comment === null || point.comment === ""
                ? null
                : point.comment
            }}</span
          >
          <span v-else> {{ point.translation }}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
.checkmark {
  transform: rotate(45deg);
  height: 20px;
  width: 12px;
  border-bottom: 3px solid #00deab;
  border-right: 3px solid #00deab;
  float: right;
  position: relative;
  top: -35px;
  right: 10px;
}
</style>
<script>
import moment from "moment";
import BgLoader from "@/components/bg-loader";
import API from "@/api";

export default {
  name: "bg-",
  components: {
    BgLoader,
  },
  props: ["videoRef", "currentTime", "scrubberTimeChange", "data", "editable"],
  methods: {},
  data() {
    return {
      displayTime: 10,
      activePoints: [],
      startedAt: this.data.started_at,
    };
  },
  watch: {
    currentTime: function(newTime) {
      const { significant_points } = this.data;
      const relativeCurrentTime = moment(this.data.started_at).add(
        newTime,
        "seconds"
      );

      const newActivePoints = (significant_points || []).filter((sp) => {
        const diff = moment(sp.timestamp_top).diff(
          relativeCurrentTime,
          "seconds"
        );
        return diff <= 7 && diff > -5;
      });
      this.activePoints = newActivePoints.sort(
        (a, b) => b.timestamp_top - a.timestamp_top
      );
    },
  },
  methods: {
    timestamp: function(ts) {
      const diff = moment(ts).diff(this.data.started_at, "seconds");
      const s = parseInt(diff % 60);
      const m = parseInt((diff / 60) % 60);
      const time = moment()
        .seconds(s)
        .minutes(m)
        .format("mm:ss");
      return time;
    },
  },
};
</script>
